import * as React from "react";
const SvgFiRrBomb = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bomb_svg__a)">
      <path
        fill="#062147"
        d="m20.236 11 .1-.102c.426-.425.66-.99.66-1.59 0-.602-.233-1.167-.658-1.592l-1.062-1.062a2.254 2.254 0 0 0-3.181 0l-.106.106c-.071.071-.175.093-.252.057-1.833-.842-3.86-1.04-5.863-.569-3.378.791-6.076 3.616-6.712 7.028-.56 3.005.342 5.952 2.474 8.085a8.9 8.9 0 0 0 6.347 2.64q.861 0 1.739-.163c3.416-.636 6.242-3.336 7.032-6.718.469-2.006.27-4.035-.575-5.868-.037-.079-.013-.182.059-.254zm-1.431 5.667c-.613 2.622-2.803 4.714-5.451 5.208-2.345.436-4.646-.265-6.305-1.925-1.66-1.66-2.36-3.958-1.923-6.305C5.62 11 7.71 8.811 10.329 8.198a7.4 7.4 0 0 1 1.669-.195c1.002 0 1.985.213 2.902.635a2.23 2.23 0 0 0 2.5-.46l.107-.106a.25.25 0 0 1 .353 0l1.06 1.062a.247.247 0 0 1-.002.355l-.1.102a2.23 2.23 0 0 0-.46 2.505c.657 1.425.81 3.007.444 4.575zM23.02 4c0 .9-.35 1.744-.986 2.38a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414 1.37 1.37 0 0 0 0-1.932 3.4 3.4 0 0 0-2.515-1c-4.956.167-8.87.94-8.91.947a1 1 0 0 1-.391-1.96C8.97.986 12.909.208 18.037.033a5.42 5.42 0 0 1 3.997 1.586c.636.636.986 1.481.986 2.38M3.48 7.016a1 1 0 0 1-.97-.757l-.356-1.43L.72 4.443a1.001 1.001 0 0 1 .035-1.94l1.403-.325L2.51.772a1 1 0 0 1 1.94.001l.354 1.418 1.418.354a1 1 0 0 1 0 1.94l-1.418.354-.354 1.418a1 1 0 0 1-.97.757z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bomb_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBomb;
